function StatsSection() {
  const stats = [
    { number: "8+", label: "Years of Legal Practice" },
    { number: "300+", label: "Successful Cases" },
    { number: "5", label: "Legal Experts" },
    { number: "100+", label: "Corporate Clients" },
  ];

  return (
    <section className="bg-deepgreen py-20 text-white relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8 text-center relative z-10">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="p-6 transition transform hover:-translate-y-1"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="text-5xl md:text-6xl font-serif font-extrabold text-gold mb-2">{stat.number}</div>
            <p className="text-sm md:text-base font-medium tracking-wider uppercase text-gray-300">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default StatsSection;
